import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Typography, Box } from "@mui/material";
import axiosInstance from "../../../services/axiosInterceptors";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import AnimatedLoader from "../../../components/AnimatedLoader";
import Header from "./Header";
import ParentWrapper from "../../../components/ParentWrapper";
import AgentCard from "./AgentCard";
import NoData from "../../../components/NoData";
import Loader from "../../../components/AnimatedLoader";






export default function AgentList() {
  const navigate = useNavigate();
  const [agentList, setAgentList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const token = localStorage.getItem("token");

  const fetchAgentList = async () => {
    try {
      const { data } = await axiosInstance.get(
        `${apiEndPointsConfig?.agentList}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAgentList(Array.isArray(data?.data) ? data.data : []);
    } catch (err) {
      console.error("agent list error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgentList();
  }, []);

  // const filtered = useMemo(() => {
  //   const merged = (Array.isArray(agentList) ? agentList : []).map((a, i) => ({
  //     ...a,
  //     rank: a?.rank || i + 1,
  //     shift: a?.shift || "9 AM - 6 PM",
  //     avatarUrl: `https://api.dicebear.com/7.x/personas/svg?seed=${encodeURIComponent(
  //       a?.agentName || "Agent"
  //     )}&radius=50&backgroundColor=f8f8f8`,

  //   }));

  //   const q = search.trim().toLowerCase();
  //   return q
  //     ? merged.filter((ag) => ag.agentName?.toLowerCase().startsWith(q))
  //     : merged;
  // }, [agentList, search]);


  // random shifts
  const shifts = ['6 AM - 3 PM', '7 AM - 4 PM', '8 AM - 5 PM', '9 AM - 6 PM', '10 AM - 7 PM', '11 AM - 8 PM', '12 PM - 9 PM'];

  // random roles
  const roles = [
    'Customer Support Agent',
    'Voice Process',
    'Technical Support Agent',
    'Sales Agent',
    'Chat Support Executive'
  ];



  const filtered = useMemo(() => {
    const merged = (Array.isArray(agentList) ? agentList : []).map((a, i) => {
      const g =
        a.gender ??
        ["male", "female", "other"][
        (a.agentName || "Agent")
          .split("")
          .reduce((h, c) => h + c.charCodeAt(0), 0) % 3
        ];

      const avatarUrl =
        g === "male"
          ? `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(
            a.agentName || "Agent"
          )}&sex=male&radius=50&backgroundColor=f8f8f8`
          : g === "female"
            ? `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(
              a.agentName || "Agent"
            )}&sex=female&radius=50&backgroundColor=f8f8f8`
            : `https://api.dicebear.com/7.x/personas/svg?seed=${encodeURIComponent(
              a.agentName || "Agent"
            )}&radius=50&backgroundColor=f8f8f8`;


      // ➜ assign random status only if backend didn't send one
      const status =
        a.status ?? (Math.random() > 0.5 ? "Active" : "inactive");

      // random shift if not provided
      const shift = a?.shift ?? shifts[Math.floor(Math.random() * shifts.length)];

      // random unique role
      const role = a?.role ?? roles[i % roles.length];

      return {
        ...a,
        gender: g,
        rank: a?.rank || i + 1,
        shift: a?.shift,
        avatarUrl,
        status,
        shift,
        role
      };
    });

    const q = search.trim().toLowerCase();
    return q
      ? merged.filter((ag) => ag.agentName?.toLowerCase().startsWith(q))
      : merged;
  }, [agentList, search]);


  return (
    <ParentWrapper>
      <Box
        sx={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        {/* Header Section */}
        {/* <Header onSearch={setSearch} /> */}
        {loading ? (
          <Loader />
        ) : (
          <>
            <Box sx={{ flex: 1, minHeight: 0}}>
              {filtered?.length === 0 ? (
                <NoData />
              ) : (
                <Grid
                  container
                  spacing={2}
                  sx={{
                    overflowY: "auto",
                    height: "100%",
                  }}
                >
                  {filtered?.map((agent) => (
                    <Grid
                      key={agent?.agentId}
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                      xl={2}
                    >
                      <AgentCard agent={agent} />
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>
          </>
        )}
      </Box>
    </ParentWrapper>
  );
}
